import { ShareEvidenceChatModal } from '@/components/modal/share-evidence-chat-modal';
import { SignUpPromptModalChat } from '@/components/modal/sign-up-prompt-modal-chat';
import {
  ArtefactPreviewModal,
  DocumentPreviewModal,
  UserDocumentsModal,
} from '@heidi/evidence';
import { useRouter } from 'next/router';
import DeleteChatDialog from './DeleteChatDialog';

interface ChatHeaderModalsProps {
  isAuthenticated: boolean;
  showSignUpModal: boolean;
  setShowSignUpModal: (open: boolean) => void;
  showUserDocsButton: boolean;
  userDocsModalOpen: boolean;
  setUserDocsModalOpen: (open: boolean) => void;
  showShareButton: boolean;
  currentChatId?: string | null;
  isShareModalOpen: boolean;
  setIsShareModalOpen: (open: boolean) => void;
  chatTitle?: string;
  isStreaming?: boolean;
  /** Delete-confirm dialog state for the chat overflow menu's Delete item. */
  isDeleteDialogOpen: boolean;
  isDeletingChat: boolean;
  onCancelDelete: () => void;
  onConfirmDelete: () => void;
}

export const ChatHeaderModals = ({
  isAuthenticated,
  showSignUpModal,
  setShowSignUpModal,
  showUserDocsButton,
  userDocsModalOpen,
  setUserDocsModalOpen,
  showShareButton,
  currentChatId,
  isShareModalOpen,
  setIsShareModalOpen,
  chatTitle,
  isStreaming,
  isDeleteDialogOpen,
  isDeletingChat,
  onCancelDelete,
  onConfirmDelete,
}: ChatHeaderModalsProps): JSX.Element => {
  // The two preview modals branch on the route themselves — a package `/ui`
  // zone may not read the router, so the mount resolves the pathname.
  const { pathname } = useRouter();

  return (
    <>
      {!isAuthenticated && (
        <SignUpPromptModalChat
          isOpen={showSignUpModal}
          onClose={() => setShowSignUpModal(false)}
        />
      )}
      {showUserDocsButton && (
        <UserDocumentsModal
          open={userDocsModalOpen}
          onOpenChange={setUserDocsModalOpen}
        />
      )}
      {showShareButton && currentChatId && (
        <ShareEvidenceChatModal
          isOpen={isShareModalOpen}
          onClose={() => setIsShareModalOpen(false)}
          chatId={currentChatId}
          chatTitle={chatTitle}
          isStreaming={isStreaming}
        />
      )}
      <DeleteChatDialog
        open={isDeleteDialogOpen}
        isDeleting={isDeletingChat}
        onCancel={onCancelDelete}
        onConfirm={onConfirmDelete}
      />
      <DocumentPreviewModal pathname={pathname} />
      <ArtefactPreviewModal pathname={pathname} />
    </>
  );
};
